var DATA = {
    TotalSales: {
        DP1: '$10,550.00',
        DP2: '-20',
        DP3: '280'
    },
    TotalLabor: {
        DP1: '$139.00',
        DP2: '15',
        DP3: '125.78'
    },
    TopItem: {
        DP1: 'IN MARTINI',
        DP2: '$469.00',
        DP3: '48'
    },
    TopServer: {
        DP1: 'Jeremy Baker',
        DP2: '$1,850.00',
        DP3: '58'
    },
    Discounts: {
        DP1: '$550.00',
        DP2: '2.3',
        DP3: '15'
    },
    Deletes: {
        DP1: '$113.65',
        DP2: '8'
    },
    Overrings: {
        DP1: '$0.00',
        DP2: '0'
    },
    Tips: {
        DP1: '$1,480.00',
        DP2: '136'
    },
    Taxes: {
        DP1: '$769.48',
        DP2: '$673.01',
        DP3: '$96.47'
    },
    Paidouts: {
        DP1: '$1300',
        DP2: '5'
    },
    DiningTimes: {
        DP1: '56.15'
    },
    LaborCost: {
        DP1: '1.34%',
        DP2: '$82.50',
        DP3: '$6,175,69'
    }
}

export default DATA